var Info = /** @class */ (function () {
    function Info(traits) {
        this.traits = traits;
        // ...
    }
    return Info;
}());
export { Info };
